<template>
  <v-card class="support-access-card pa-6" elevation="0" outlined rounded="xl">
    <div class="text-center">
      <v-progress-circular v-if="loading" indeterminate color="primary" size="44" aria-label="Opening customer account" />
      <v-icon v-else-if="error" color="error" size="48" aria-hidden="true">mdi-alert-circle-outline</v-icon>
      <v-icon v-else color="success" size="48" aria-hidden="true">mdi-shield-account</v-icon>
      <h1 class="text-h5 font-weight-bold mt-4 mb-2">{{ error ? "Support access unavailable" : "Opening customer account" }}</h1>
      <p class="text-body-2 mb-4" aria-live="polite">{{ message }}</p>
      <v-btn v-if="error" color="primary" large to="/login">Back to sign in</v-btn>
    </div>
  </v-card>
</template>

<script>
import authService from "../service";
import { saveSupportSession } from "../supportSession";

export default {
  name: "BackOfficeSupportAccess",
  data: () => ({ loading: true, error: false, message: "Verifying the one-time audited support session…" }),
  watch: {
    "$route.query.status"(status) {
      if (status === "invalid") this.fail();
    },
  },
  async created() {
    if (this.$route.query.status === "opening") return;
    if (this.$route.query.status === "invalid") return this.fail();
    const match = String(window.location.hash || "").match(/^#code=([A-Za-z0-9_-]{43})$/);
    window.history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}`);
    if (!match) return this.fail();
    try {
      const session = await authService.exchangeSupportAccess(match[1]);
      if (!session || !session.token || !session.organizationId || !session.expiresAt) return this.fail();
      saveSupportSession(session);
      this.message = "Support access verified. Redirecting…";
      await this.$router.replace("/home");
    } catch (error) {
      this.fail();
    }
  },
  methods: {
    fail() {
      this.loading = false;
      this.error = true;
      this.message = "This one-time support link is invalid, expired, or has already been used. Return to CRM and start a new session.";
    },
  },
};
</script>

<style scoped>
.support-access-card { max-width: 460px; width: 100%; }
</style>
